import axios from "axios";
import { APIAddress } from "constants/config";
import queryString from 'query-string';

export default function getClassLesson(classId, params) {

	let query = queryString.stringify({
		per_page: params.amount_per_page,
		page: params.current_page_number,
		after_today: params.after_today,
		detail: params.detail
	});
	
	return new Promise((resolve, reject)=>{
		axios.put(APIAddress, {
        'uri': `/g_cls_lss/${classId}/?${query}`,
				'method': 'GET',
				'token': localStorage.getItem('token'),
			})
      .then((res) => {
        resolve(res.data);

			})
      .catch((err) => {
        reject(err);
      })

	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/class/getClassLesson.js